import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Layout } from './Dashboard';
import { API } from '../App';
import { toast } from 'sonner';
import { Plus, Trash2, Home } from 'lucide-react';

const AccommodationTypes = () => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [newType, setNewType] = useState({ name: '' });

  useEffect(() => {
    loadTypes();
  }, []);

  const loadTypes = async () => {
    try {
      const res = await axios.get(`${API}/accommodation-types`);
      setTypes(res.data);
    } catch (error) {
      toast.error('Failed to load accommodation types');
    } finally {
      setLoading(false);
    }
  };

  const createType = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/accommodation-types`, newType);
      toast.success('Accommodation type created!');
      setShowModal(false);
      setNewType({ name: '' });
      loadTypes();
    } catch (error) {
      toast.error('Failed to create type');
    }
  };

  const deleteType = async (id) => {
    if (!window.confirm('Delete this accommodation type?')) return;
    try {
      await axios.delete(`${API}/accommodation-types/${id}`);
      toast.success('Type deleted');
      loadTypes();
    } catch (error) {
      toast.error('Failed to delete type');
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="text-center py-12">Loading...</div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Accommodation Types</h2>
          <button
            onClick={() => setShowModal(true)}
            className="w-full sm:w-auto flex items-center justify-center space-x-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            <Plus className="w-4 h-4" />
            <span>New Type</span>
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {types.map((type) => (
            <div key={type.id} className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <Home className="w-6 h-6 text-blue-600" />
                    <h3 className="text-xl font-semibold text-gray-900">{type.name}</h3>
                  </div>
                </div>
                <button
                  onClick={() => deleteType(type.id)}
                  className="text-red-600 hover:text-red-700"
                >
                  <Trash2 className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Create Modal */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-xl shadow-xl p-6 max-w-md w-full">
              <h3 className="text-2xl font-bold mb-4">New Accommodation Type</h3>
              <form onSubmit={createType} className="space-y-4">
                <input
                  type="text"
                  placeholder="Type Name (e.g., Room, Dorm, Bungalow)"
                  required
                  value={newType.name}
                  onChange={(e) => setNewType({ name: e.target.value })}
                  className="w-full px-3 py-2 border rounded"
                />
                <div className="flex space-x-3">
                  <button
                    type="submit"
                    className="flex-1 bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
                  >
                    Create
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="flex-1 bg-gray-600 text-white py-2 rounded hover:bg-gray-700"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default AccommodationTypes;
